import React, { useState, useEffect } from "react";
//import { useHistory } from "react-router-dom";
import "./Ratings.css";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getImage } from "../../utilities/storageOperations/downloadURL";
import {
  clearRatingCheck,
  getRating,
  postRatingreviews,
  putRatingreviews,
} from "../../redux/actions";
import greenTick from "../../assets/img/GreenTick.png";
import { LoadingOutlined } from "@ant-design/icons";
import history from "../../routes/history";

import moment from "moment";

import { Rate, Button } from "antd";
import Loader from "../../components/Loading/Loader";

const Rating = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const ratingData = useSelector((state) => state.getRatingReducer.data);
  const bidId = location.state.bidId;
  const proposalId = location.state.proposalId;
  const image = location.state.image;
  const candidate_name_ = location.state.candidate_name;
  const skill_listing_title_ = location.state.skill_listing_title ? location.state.skill_listing_title : ratingData[0]?.SkillListingTitle ? ratingData[0]?.SkillListingTitle : null;
  const date_from = location.state.date_from ? location.state.date_from : ratingData[0]?.offers?.FromDate ? ratingData[0]?.offers : null;
  const date_to = location.state.date_to ? location.state.date_to : ratingData[0]?.offers?.ToData ? ratingData[0]?.ToDate : null;
  const rating = location.state.rating ? location.state.rating : ratingData[0]?.rating ? ratingData[0]?.rating : null;
  const previousScreen_ = location.state.previousScreen;
  const isEdit_ = location.state.isEdit;
  const Reviewee = location.state.Reviewee;
  const job_title_ = location.state.job_title;
  const SourceId = location.state.SourceTypeId == 1 ? "Bid" : "Proposal"
  const ratings_loading = useSelector((state) => state.ratingReducer.loading);
  const rating_page_loading = useSelector((state) => state.getRatingReducer.loading);
  const ratings_success = useSelector(
    (state) => state.ratingReducer.ratingSuccess
  );
  // const ratings_loading = useSelector(state => state.ratingsReducer.)

  const state_ = location.state;
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [showExample, setShowExample] = useState(false);
  const [previousScreen, setPreviousScreen] = useState("");
  const [job_title, setJob_title] = useState("");

  const [countCom, setCountCom] = useState(0);
  const [countWork, setCountWork] = useState(0);
  const [countRec, setCountRec] = useState(0);

  const [review, setReview] = useState("");
  const [wordCount, setWordCount] = useState(0);

  const [BidId, setBidId] = useState(false);
  const [ratings_Id, setRatings_Id] = useState(false);
  const [skill_listing_title, setSkill_listing_title] = useState(
    "Skill listing Title Lorem Ipsum"
  );
  const [candidate_name, setCandidate_name] = useState("Candidate name");

  const [dateFrom, setDateFrom] = useState("MM/DD/YYYY");
  const [dateTo, setDateTo] = useState("MM/DD/YYYY");

  const [isEdit, setIsEdit] = useState(false);

  const [ratingError, setRatingError] = useState(false);
  const [feedbackError, setFeedbackError] = useState(false);
  const [ratingSubmissionSuccess, setRatingSubmissionSuccess] = useState(false);
  const [profilePic, setProfilePic] = useState("");

  useEffect(()=>{
    dispatch(getRating({
      id: bidId || proposalId,
      type: SourceId
    }));
  
},[])

  useEffect(() => {
    setBidId(bidId);
    setSkill_listing_title(skill_listing_title_);
    setJob_title(job_title_);
    setCandidate_name(candidate_name_);

    setDateFrom(moment(date_from).format("MMMM DD,YYYY"));
    setDateTo(moment(date_to).format("MMMM DD,YYYY"));

    setPreviousScreen(previousScreen_);
    dispatch(clearRatingCheck());
  }, [ratingData]);


  useEffect(()=>{
    if (isEdit_ || rating?.ConsultantRating) {
      setIsEdit(true); 
      if (rating) {
        setCountCom(rating.ConsultantRating?.Communication);
        setCountWork(rating.ConsultantRating?.WorkingKnowledge);
        setCountRec(rating.ConsultantRating?.Recommendation);
        setReview(rating.ConsultantComment);
        
        setJob_title(job_title_);
        setWordCount(rating?.ConsultantComment.length);
        setRatings_Id(rating._id);
      }
    }
  },[isEdit_ ,ratingData])

  useEffect(async () => {
    let profilePic = "";
    if (image) {
      profilePic = await getImage(image);
    }

    setProfilePic(profilePic);
  }, [image]);

  useEffect(() => {
    if (ratings_success) {
      setRatingSubmissionSuccess(true);
      dispatch(clearRatingCheck())
    }
    if (isEdit_ && !ratings_success) {
      setRatingSubmissionSuccess(false);
    }
  }, [ratings_success, isEdit_]);

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const handleReviewChange = (event) => {
    setReview(event.target.value);
  };

  const handleSubmitRatings = () => {
    if (countCom == 0 || countWork == 0 || countRec == 0) {
      setRatingError(true);
      setTimeout(() => {
        setRatingError(false);
      }, 3000);
    }

    if (countCom != 0 && countWork != 0 && countRec != 0) {
      setRatingError(false);
    }

    // if (review == null || review?.length == 0) {
    //   setFeedbackError((prevVal) => !prevVal);
    // }

    if (review?.length != 0) {
      setFeedbackError(false);
    } else {
      setFeedbackError(true);
    }

    if (
      countCom != 0 &&
      countWork != 0 &&
      countRec != 0 &&
      review?.length != 0
    ) {
      setRatingError(false);
      setFeedbackError(false);
      if (isEdit) {
        dispatch(
          putRatingreviews({
            type: SourceId,
            Ratings_id: bidId || proposalId,
            ConsultantComment: review,
            ConsultantRating: {
              Communication: countCom,
              WorkingKnowledge: countWork,
              Recommendation: countRec,
            },
            type: SourceId,
            Reviewee: Reviewee,
          })
        );
        // dispatch(clearRatingCheck())
      } else {
        dispatch(
          postRatingreviews({
            [SourceId == 'Bid' ? 'BidId' : 'ProposalId'] : BidId || proposalId,
            type: SourceId,
            ConsultantComment: review,
            Reviewee: Reviewee,
            ConsultantRating: {
              Communication: countCom,
              WorkingKnowledge: countWork,
              Recommendation: countRec,
            },
          })
        );
      }
    }
    dispatch(clearRatingCheck())
    setRatingSubmissionSuccess(false)
  };

  return (
    (rating_page_loading ?
    <Loader /> :
    <div className="Ratings-main-container">
      <div
        className={
          Dimensions.width < 769
            ? "Ratings-container-mobile"
            : "Ratings-container"
        }
      >
        <div className="Ratings-Breadcrum">
          <span
            className="Ratings-previousScreen"
            onClick={() =>
              history.push({
                pathname:
                  previousScreen === "Messages"
                    ? "/conversations"
                    : previousScreen === "Manage Candidates" ?
                      "/managecandidate" : "/employerdashboard" ,
                state: {
                  openConvo: true,
                  conversationId: location.state.conversationId,
                },
              })
            }
          >
            {previousScreen}
          </span>
          <span style={{ marginLeft: "0.7rem" }}>{`>`}</span>
          <span style={{ marginLeft: "0.7rem" }}>{`Rate`}</span>
        </div>

        {Dimensions.width > 769 && !ratingSubmissionSuccess ? (
          <div className="Ratings-heading">Provide Feedback</div>
        ) : null}

        {!ratingSubmissionSuccess && (
          <div className="Ratings-imageRow">
            <div
              className="Ratings-picContainer"
              style={{
                width: profilePic == null || (profilePic == "" && "2.5rem"),
                height: profilePic == null || (profilePic == "" && "2.5rem"),
              }}
            >
              {profilePic == null || profilePic == "" ? (
                candidate_name?.charAt(0)?.toUpperCase()
              ) : (
                <img
                  className="Ratings-recipent_image"
                  src={profilePic}
                  alt="recipent image"
                />
              )}
            </div>

            <div className="Ratings-Job-CandidateName-Container">
              <div className="Ratings-Job-Title">
                {job_title_}
              </div>
              <div className="Ratings-Candidate-Name">{candidate_name}</div>
            </div>
          </div>
        )}

        {!ratingSubmissionSuccess ? (
          <>
            {Dimensions.width > 769 ? (
              <>
                <div className="Ratings-line-divider"></div>
                <div className="Ratings-heading">Ratings</div>
              </>
            ) : null}

            <div className="Ratings-Communication-Row">
              <div className="Ratings-Communication-Text">Communication</div>

              <Rate
                defaultValue={countCom}
                allowHalf
                onChange={(value) => {
                  setCountCom(value);
                }}
                value={countCom}
                style={{ color: "#ffba08" }}
                fill="#ffba08"
                className="ratings-stars"
              />
            </div>

            <div className="Ratings-WorkKnowledge-Row">
              <div className="Ratings-WorkKnowledge-Text">Work knowledge</div>

              <Rate
                defaultValue={countWork}
                allowHalf
                onChange={(value) => {
                  setCountWork(value);
                }}
                value={countWork}
                style={{ color: "#ffba08" }}
                className="ratings-stars"
              />
            </div>

            <div className="Ratings-Recommend-Row">
              <div className="Ratings-Recommend-Text">Would recommend</div>
              <Rate
                defaultValue={countRec}
                allowHalf
                onChange={(value) => {
                  setCountRec(value);
                }}
                value={countRec}
                style={{ color: "#ffba08" }}
                className="ratings-stars"
              />
            </div>

            {ratingError ? (
              <div className="Ratings-rating-error">Please provide rating</div>
            ) : null}

            {Dimensions.width > 769 ? (
              <div className="Ratings-line-divider"></div>
            ) : null}

            <div className="reviewDiv">
              <div className="Ratings-share-experience-text">
                Share your experience with this candidate to the SkillGigs and
                to the public
              </div>
              <br />
              <textarea
                value={review}
                onChange={(e) => {
                  setWordCount(e.target.value.length);
                  handleReviewChange(e);
                  setFeedbackError(false);
                }}
                maxlength={5000}
                className={
                  wordCount < 5000 && !feedbackError
                    ? "Ratings-normal-drawer"
                    : "Ratings-full-drawer"
                }
                placeholder="What did you like or dislike?"
              />

              <div
                className={
                  wordCount < 5000
                    ? "Ratings-count-drawer"
                    : "Ratings-count-finish-drawer"
                }
              >
                <span id="Ratings-current-word-count">{wordCount}</span>
                <span id="Ratings-maximum-word-count"> / 5000</span>
              </div>

              {feedbackError ? (
                <div className="Ratings-feedback-error">
                  Please provide your feedback
                </div>
              ) : null}

              <div className="Ratings-appropriate-feedback">
                See an example of{" "}
                <span
                  onClick={() => setShowExample((prevState) => !prevState)}
                  style={{ color: "#118936", cursor: "pointer" }}
                >
                  appropriate feedback
                </span>
              </div>

              <div
                className={
                  showExample
                    ? "Ratings-example-text"
                    : "Ratings-example-text-hide"
                }
              >
                The candidate is professional.I look forward to working with them
                again.
              </div>

              <div className="Ratings-line-divider"></div>

              <div className="Ratings-Submit-Btn-Container">
                <Button
                  className="Ratings-Submit-Btn"
                  onClick={() => handleSubmitRatings()}
                  disabled={ratings_loading}
                >
                  <div className="Ratings-Submit-Text">
                    {ratings_loading ? (
                      <LoadingOutlined />
                    ) : isEdit ? (
                      "Update"
                    ) : (
                      "Submit"
                    )}
                  </div>
                </Button>
              </div>
            </div>
          </>
        ) : (
          <div className="Ratings-thankyou-container">
            <div className="Ratings-greenTickContainer">
              <img src={greenTick} className={"greenTick-pic"} />
            </div>
            <div className="Ratings-thankyou-heading">Thank you !</div>
            <div className="Ratings-thankyou-text">
              We are processing your review. Your reviews will appear within 14
              days, so we appreciate your patience. We will notify you when this
              is complete.
            </div>
          </div>
        )}
      </div>
    </div>)
  );
};

export default Rating;
